import { render, staticRenderFns } from "./turntable.vue?vue&type=template&id=07cd1405&scoped=true"
import script from "./turntable.vue?vue&type=script&lang=js"
export * from "./turntable.vue?vue&type=script&lang=js"
import style0 from "./turntable.vue?vue&type=style&index=0&id=07cd1405&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd1405",
  null
  
)

export default component.exports